

import React, { useState } from "react";
import LineChartGraph2 from "./InverterCompare";
import DailyIrrad from './IrradianceCompare'
import  DayTemperatureCompare from './Temperature';
import DayWisePowerSensorChart from './DaywisePowersensor';
import { format } from 'date-fns';

const ComparePlant = () => {
  const selectedDate = new Date();
  const month = format(selectedDate, 'yyyy-MM');

  const [selectedType, setSelectedType] = useState("Inverter");

  const handleButtonClick = (type) => {
    setSelectedType(type);
  };

  return (
    <div className="chart-container" style={{ padding: '20px' }}>
      <h2 style={{ marginBottom: '20px' }}>
        Comparison of <strong>Sweelee</strong> - Huawei and Trek Datalogger
      </h2>

      <div style={{ marginBottom: '20px' }}>
  {['Inverter', 'Irradiance', 'PowerMeter', 'Temperature'].map((type) => (
    <button
      key={type}
      onClick={() => handleButtonClick(type)}
      style={{
        marginRight: '10px',
        backgroundColor: selectedType === type ? '#007bff' : '#e0e0e0',
        color: selectedType === type ? '#fff' : '#000',
        padding: '8px 12px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease'
      }}
    >
      {type}
    </button>
  ))}
</div>

    
      {selectedType === "Inverter" && (
        <LineChartGraph2 month={month} type={selectedType} />
      )}
      {selectedType === "Irradiance" && <DailyIrrad month={month} type="Irradiance" />}
      {selectedType === "PowerMeter" && <DayWisePowerSensorChart month={month} type="PowerMeter" />}
      {selectedType === "Temperature" && <DayTemperatureCompare />}
    </div>
  );
};

export default ComparePlant;
